//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AbpApplicationLocalizationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type AbpApplicationLocalizationGetAbpApplicationLocalizationQueryParameters = {
  cultureName: string ;
  onlyDynamics?: boolean | undefined ;
}

export function abpApplicationLocalizationGetUrl(cultureName: string, onlyDynamics?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/abp/application-localization?";
  if (cultureName === undefined || cultureName === null)
    throw new Error("The parameter 'cultureName' must be defined and cannot be null.");
  else
    url_ += "CultureName=" + encodeURIComponent("" + cultureName) + "&";
if (onlyDynamics === null)
    throw new Error("The parameter 'onlyDynamics' cannot be null.");
else if (onlyDynamics !== undefined)
    url_ += "OnlyDynamics=" + encodeURIComponent("" + onlyDynamics) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let abpApplicationLocalizationGetDefaultOptions: Omit<UseQueryOptions<Types.ApplicationLocalizationDto, unknown, Types.ApplicationLocalizationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ApplicationLocalizationDto, unknown, Types.ApplicationLocalizationDto>, 'queryFn'>> = {
};
export function getAbpApplicationLocalizationGetDefaultOptions() {
  return abpApplicationLocalizationGetDefaultOptions;
};
export function setAbpApplicationLocalizationGetDefaultOptions(options: typeof abpApplicationLocalizationGetDefaultOptions) {
  abpApplicationLocalizationGetDefaultOptions = options;
}

export function abpApplicationLocalizationGetQueryKey(dto: AbpApplicationLocalizationGetAbpApplicationLocalizationQueryParameters): QueryKey;
export function abpApplicationLocalizationGetQueryKey(cultureName: string, onlyDynamics?: boolean | undefined): QueryKey;
export function abpApplicationLocalizationGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { cultureName, onlyDynamics,  } = params[0] as AbpApplicationLocalizationGetAbpApplicationLocalizationQueryParameters;

    return trimArrayEnd([
        'AbpApplicationLocalizationClient',
        'abpApplicationLocalizationGet',
        cultureName as any,
        onlyDynamics as any,
      ]);
  } else {
    return trimArrayEnd([
        'AbpApplicationLocalizationClient',
        'abpApplicationLocalizationGet',
        ...params
      ]);
  }
}
export function __abpApplicationLocalizationGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.abpApplicationLocalizationGet(
      context.queryKey[2] as string,       context.queryKey[3] as boolean | undefined,axiosConfig    );
}

export function useAbpApplicationLocalizationGetQuery<TSelectData = Types.ApplicationLocalizationDto, TError = unknown>(dto: AbpApplicationLocalizationGetAbpApplicationLocalizationQueryParameters, options?: Omit<UseQueryOptions<Types.ApplicationLocalizationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param onlyDynamics (optional) 
 * @return OK
 */
export function useAbpApplicationLocalizationGetQuery<TSelectData = Types.ApplicationLocalizationDto, TError = unknown>(cultureName: string, onlyDynamics?: boolean | undefined, options?: Omit<UseQueryOptions<Types.ApplicationLocalizationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAbpApplicationLocalizationGetQuery<TSelectData = Types.ApplicationLocalizationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ApplicationLocalizationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let cultureName: any = undefined;
  let onlyDynamics: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ cultureName, onlyDynamics,  } = params[0] as AbpApplicationLocalizationGetAbpApplicationLocalizationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [cultureName, onlyDynamics, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ApplicationLocalizationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __abpApplicationLocalizationGet(context, axiosConfig) : __abpApplicationLocalizationGet,
    queryKey: abpApplicationLocalizationGetQueryKey(cultureName, onlyDynamics),
    ...abpApplicationLocalizationGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.ApplicationLocalizationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param onlyDynamics (optional) 
 * @return OK
 */
export function setAbpApplicationLocalizationGetData(queryClient: QueryClient, updater: (data: Types.ApplicationLocalizationDto | undefined) => Types.ApplicationLocalizationDto, cultureName: string, onlyDynamics?: boolean | undefined) {
  queryClient.setQueryData(abpApplicationLocalizationGetQueryKey(cultureName, onlyDynamics),
    updater
  );
}

/**
 * @param onlyDynamics (optional) 
 * @return OK
 */
export function setAbpApplicationLocalizationGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ApplicationLocalizationDto | undefined) => Types.ApplicationLocalizationDto) {
  queryClient.setQueryData(queryKey, updater);
}